require('angular').module('wowApp.common')
    .service('HeartbeatService', ['$interval', 'Restangular', 'ShopperService', 'config', '$window', require('./heartbeat.service')])
    .run([
        'HeartbeatService', function (heartbeatService) {
            heartbeatService.startContextHeartbeat();
        },
    ]);



// WEBPACK FOOTER //
// ./src/common/heartbeat/index.js